// QueTeleport (깨텔레포트) Constants

// Grid dimensions
export const GRID_SIZE = 10

// Cell sizing (same as QueBoard for visual consistency)
export const CELL_SIZE = 50
export const CELL_GAP = 2
export const BOUNDARY_GAP = 8 // extra gap every 5 cells

// === LEFT PANEL ===
export const LEFT_PANEL_X = 10
export const LEFT_PANEL_WIDTH = 230

// Problem display
export const PROBLEM_Y = 10
export const PROBLEM_HEIGHT = 80

// Answer display
export const ANSWER_Y = PROBLEM_Y + PROBLEM_HEIGHT + 10 // 100
export const ANSWER_HEIGHT = 100

// Control panel - Teleport buttons
export const TELEPORT_SECTION_Y = ANSWER_Y + ANSWER_HEIGHT + 16 // 216
export const TELEPORT_SECTION_HEIGHT = 84

// Control panel - Remove buttons
export const REMOVE_SECTION_Y = TELEPORT_SECTION_Y + TELEPORT_SECTION_HEIGHT + 12 // 312
export const REMOVE_SECTION_HEIGHT = 84

// Toolbar (rearrange + reset)
export const TOOLBAR_Y = REMOVE_SECTION_Y + REMOVE_SECTION_HEIGHT + 12 // 408
export const TOOLBAR_HEIGHT = 40

// Button sizing
export const BUTTON_WIDTH = 105
export const BUTTON_HEIGHT = 34
export const BUTTON_GAP = 8

// === RIGHT PANEL (Grid) ===
export const GRID_OFFSET_X = LEFT_PANEL_WIDTH + 30 // 260
export const GRID_OFFSET_Y = 10

// Grid extent (calculated)
export const GRID_EXTENT = GRID_SIZE * (CELL_SIZE + CELL_GAP) + BOUNDARY_GAP // 528

// === Stage dimensions ===
export const STAGE_WIDTH = GRID_OFFSET_X + GRID_EXTENT + 20 // 808
export const STAGE_HEIGHT = Math.max(GRID_EXTENT + GRID_OFFSET_Y + 20, TOOLBAR_Y + TOOLBAR_HEIGHT + 20) // 558

// Colors (QueBoard warm palette + blue blocks)
export const COLORS = {
  // Block states
  blockOn: '#5C9CE6',
  blockEmpty: 'transparent',
  blockHighlightSource: '#FFD54F',  // yellow (teleport source)
  blockHighlightTarget: '#81C784',  // green (teleport target)
  blockDashedEmpty: '#EF6C00',      // orange dashed (vacated position)
  blockComplete: '#FFD54F',         // yellow (completion highlight)

  // Grid background (QueBoard checkerboard)
  panelA: '#FAEBD7',
  panelB: '#F5DEB3',
  background: '#F5E6C8',

  // Text
  textPrimary: '#3E2723',
  textSecondary: '#6D4C41',
  textLight: '#FFFFFF',

  // Buttons
  teleportButton: '#2196F3',
  teleportButtonHover: '#1976D2',
  removeButton: '#7B1FA2',
  removeButtonHover: '#6A1B9A',
  utilButton: '#43A047',
  utilButtonHover: '#388E3C',
  resetButton: '#9E9E9E',
  resetButtonHover: '#757575',
  buttonDisabled: '#BCAAA4',

  // Section labels
  sectionLabel: '#6D4C41',

  // Feedback
  success: '#4CAF50',
  error: '#F44336',
  info: '#2196F3',
} as const
